import Modal from 'react-bootstrap/Modal';
import React from 'react';

const CustomModal = ({ children, title, ...restProps }) => {
    return (
        <Modal {...restProps} centered fullscreen={'sm-down'}>
            <Modal.Header
                className="text-center"
                closeButton
                closeVariant="white"
            >
                <Modal.Title className="text-white w-100">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
        </Modal>
    );
};

export default CustomModal;
